import { PSTN_SERVICE_NAME } from './constants';

export const extractPstnItemFromTelephonyItems = (
  rows: InventoryTelephonyItem[] | TelephonyItem[],
): TelephonyItem | InventoryTelephonyItem | undefined =>
  [...rows].find((telephonyItem) => telephonyItem.name === PSTN_SERVICE_NAME);
